import { graphql } from 'react-relay';

export const widgetFragment = graphql`
  fragment Widget_component on Widget
  @argumentDefinitions(
    salesAdmission: {type: "String!"}
    componentsCount: {type: "Int", defaultValue: 1000}
  ) {
      header
      name
      components(first: $componentsCount) {
        edges {
          node {
            id
            __typename
            ...FundsManager_component
            ...CompositionChart_component
            ...ItemList_component
            ...Documents_component @arguments(salesAdmission: $salesAdmission)
          }
        }
      }
  }
`;
